<template>
    <router-view />
</template>

<script>
export default {
  name: "LoginModule"
};
</script>